import React, { Suspense, useContext } from 'react'
import { Accordion, AccordionItem } from '../../../commonComponents/accordion';
import CustomTooltip from '../../../commonComponents/customTooltip';
import { Checkbox } from 'semantic-ui-react';
import ActorDetailHeader from './actorDetailHeader';
import { useCurrentShipmentType } from "../../../hooks/useCurrentShipmentType";
import CopyActorLogic from './CopyActorLogic';
import { Carrier, Surety, Agent, Declarant, Consignor, Consignee, Exporter, Importer, Buyer, Seller, FiscalRepresentative } from './Actors';
import ActorDetailForm from '../../../commonComponents/formComponents/actorDetailForm'
import { ActorContext } from './Actors/actorProvider'
import PartiesTabError from './Actors/PartiesTabError'
const Authorization = React.lazy(() => import("./authorization"))
const SupplyChainActor = React.lazy(() => import("./supplyChainActor"))
const Payment = React.lazy(() => import("./payment"))
const Guarantee = React.lazy(() => import("./guarantee"))
const AdditonalGuarantee = React.lazy(() => import("./additonalGuarantee"))

const PartiesForm = (props) => {

  const { translate } = props;
  const { isImportShipment, isDMS } = useCurrentShipmentType()
  const actorDetails = useContext(ActorContext)

  const actorDetailForm = (params) => {
    return <PartiesTabError actorType={params?.actorType}>
      {(errorInfo) => <ActorDetailForm {...params} {...actorDetails} errorInfo={errorInfo} ></ActorDetailForm>}
    </PartiesTabError>
  }

  return (
    <div className="parties formContentareaC88">

      <Accordion translate={translate}>
        <AccordionItem idText={`consignor-toggle`} rightHeader={!isImportShipment && isDMS ? <CopyActorLogic actorType="consignor" renderProps={({ copiedActorStatus, copyActorDetails }) => {
          return (
            <CustomTooltip className="copyTo" title="COPY TO">
              <div className='copyToContainer'>
                {
                  Object.entries(copiedActorStatus).map(([key, value]) => {
                    return (
                      <Checkbox checked={value} name={key} onChange={copyActorDetails} label={<label>{key.toUpperCase()}</label>} />
                    )
                  })
                }
              </div>
            </CustomTooltip>
          )
        }}>
        </CopyActorLogic> : null} id="1" title={(props) => (
          <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title={isDMS ? "CONSIGNOR" : "SHIP FROM"} actorType="consignor" {...props}></ActorDetailHeader>
        )}>
          <Consignor renderForm={actorDetailForm}></Consignor>
        </AccordionItem>

        <AccordionItem idText={`consignee-toggle`} rightHeader={isImportShipment ? <CopyActorLogic actorType="consignee" renderProps={({ copiedActorStatus, copyActorDetails }) => {

          return (
            <CustomTooltip className="copyTo" title="COPY TO">
              <div className='copyToContainer'>
                {
                  Object.entries(copiedActorStatus).map(([key, value]) => {
                    return (
                      <Checkbox checked={value} name={key} onChange={copyActorDetails} label={<label>{key.toUpperCase()}</label>} />
                    )
                  })
                }
              </div>
            </CustomTooltip>
          )
        }} ></CopyActorLogic> : null} id="2"
          title={(props) => (
            <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title="CONSIGNEE" actorType="consignee" {...props}></ActorDetailHeader>
          )}
        >
          <Consignee renderForm={actorDetailForm}></Consignee>
        </AccordionItem>
        <AccordionItem id="3" idText={`agent-toggle`} title={(props) => (
          <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title="AGENT" actorType="agent" {...props}></ActorDetailHeader>
        )}>
          <Agent isDMS={isDMS} isImportShipment={isImportShipment} renderForm={actorDetailForm} />
        </AccordionItem>
        <AccordionItem id="4" idText={`declarant-toggle`} title={(props) => (
          <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title="DECLARANT" actorType="declarant" {...props}></ActorDetailHeader>
        )}>
          <Declarant isDMS={isDMS} renderForm={actorDetailForm} />

        </AccordionItem>
        {isImportShipment &&
          <AccordionItem id="5" idText={`importer-toggle`} title={(props) => (
            <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title="IMPORTER" actorType="importer" {...props}></ActorDetailHeader>
          )}>
            <Importer renderForm={actorDetailForm}></Importer>

          </AccordionItem>
        }
        <AccordionItem id="6" idText={`exporter-toggle`} title={(props) => (
          <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title="EXPORTER" actorType="exporter" {...props}></ActorDetailHeader>
        )}>
          <Exporter renderForm={actorDetailForm}></Exporter>
        </AccordionItem>
        {isImportShipment &&
          <React.Fragment>
            <AccordionItem id="7" idText={`buyer-toggle`} title={(props) => (
              <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title="BUYER" actorType="buyer" {...props}></ActorDetailHeader>
            )}>
              <Buyer renderForm={actorDetailForm} ></Buyer>
            </AccordionItem>
            <AccordionItem id="8" idText={`declarant-toggle-8`} title={(props) => (
              <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title="SELLER" actorType="declarant" {...props}></ActorDetailHeader>
            )}>
              <Seller renderForm={actorDetailForm} ></Seller>
            </AccordionItem>
            <AccordionItem id="9" idText={`declarant-toggle-9`} title={(props) => (
              <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title="SURETY" actorType="declarant" {...props}></ActorDetailHeader>
            )}>
              <Surety renderForm={actorDetailForm} ></Surety>
            </AccordionItem>
            <AccordionItem id="10" idText={`declarant-toggle-10`} title={(props) => (
              <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title="FISCAL_REPRESENTATIVE" actorType="declarant" {...props}></ActorDetailHeader>
            )}>
              <FiscalRepresentative renderForm={actorDetailForm} ></FiscalRepresentative>
            </AccordionItem>
          </React.Fragment>
        }
        {
          !isImportShipment && isDMS &&
          <AccordionItem id="11" idText={`carrier-toggle`} title={(props) => (
            <ActorDetailHeader isImportShipment={isImportShipment} isDMS={isDMS} title="CARRIER" actorType="carrier" {...props}></ActorDetailHeader>
          )}>
            <Carrier renderForm={actorDetailForm}></Carrier>
          </AccordionItem>
        }
      </Accordion>
      <Suspense fallback={<div>Loading...</div>}>
        {
          isDMS && <Authorization />
        }
        {
          isDMS &&
          <SupplyChainActor />
        }

        {isImportShipment &&
          <React.Fragment>
            <Payment />

            <Guarantee />
            <AdditonalGuarantee />
          </React.Fragment>
        }
      </Suspense>

    </div>

  )
}

export default React.memo(PartiesForm)